import { HttpTypes } from "@medusajs/types"
import { Text } from "@medusajs/ui"

type LineItemOptionsProps = {
  variant: HttpTypes.StoreProductVariant | undefined
  "data-testid"?: string
  "data-value"?: HttpTypes.StoreProductVariant
}

const LineItemOptions = ({
  variant,
  "data-testid": dataTestid,
  "data-value": dataValue,
}: LineItemOptionsProps) => {
  return (
    <Text
      data-testid={dataTestid}
      data-value={dataValue}
      className="inline-block txt-medium text-ui-fg-subtle w-full overflow-hidden text-ellipsis"
    >
      {/* Tytuł wariantu niesie komplet opcji ("Czarny / M"), odkąd koszulki
          mają też kolor. Zaszyta etykieta "Rozmiar:" kłamałaby, a opcji
          wariantu koszyk nie pobiera (fields: *items.variant, bez .options). */}
      {variant?.title}
    </Text>
  )
}

export default LineItemOptions
